/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { SearchSnowstormConcept } from './SearchSnowstormConcept'; 

export function searchBodyStructuresOptions(searchTerm: string, onSuccess?: (result: SearchSnowstormConcept[]) => void) {
	return queryOptions({
		queryKey: ['search-body-structures', searchTerm],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/libraries/concepts/queries/searchbodystructures/' + searchTerm;
			const resp = await axios.get<SearchSnowstormConcept[]>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(searchTerm)
	});
}